import { render, staticRenderFns } from "./schoolClassAdd.vue?vue&type=template&id=7340188f&scoped=true&"
import script from "./schoolClassAdd.vue?vue&type=script&lang=js&"
export * from "./schoolClassAdd.vue?vue&type=script&lang=js&"
import style0 from "./schoolClassAdd.vue?vue&type=style&index=0&id=7340188f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7340188f",
  null
  
)

export default component.exports